import { render, staticRenderFns } from "./StandardLabels.vue?vue&type=template&id=58909501"
import script from "./StandardLabels.vue?vue&type=script&lang=js"
export * from "./StandardLabels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports